<mat-card class="card-demo">
  <mat-card-title class="topline">
    <h2>
      Audit Template: {{ auditName }}@if (!sharePermission) {
      <b>(View Only)</b>
      }
    </h2>
    <button mat-button (click)="onBackSummary()">
      <mat-icon aria-hidden="true" aria-label="Next">arrow_back</mat-icon>Back
      to Summary
    </button>
  </mat-card-title>
  <mat-card-content class="large">
    <div fxLayout="column" fxFill>
      <div fxLayout fxFlex>
        <div class="one" fxFlex="70" fxLayoutAlign="start start">
          <app-answer-question
            [appSect$]="this.appSect$"
            [rbName]="this.selectedRbName"
            [editable]="this.sharePermission"
            (answerApp)="onAnswerApp($event)"
          >
          </app-answer-question>
        </div>
        <div class="two" fxFlex="30" fxLayoutAlign="start start">
          <app-list-rulebook
            [csskey]="this.csskey"
            [auditName]="this.auditName"
            [rbList]="this.rulebookList"
            [selected]="this.appkey"
            (selectedAppkey)="onClickRulebook($event)"
            class="list-rulebook"
          >
          </app-list-rulebook>
        </div>
      </div>
    </div>
  </mat-card-content>
  <mat-card-footer class="bottomPad">
    <div class="hint"></div>
  </mat-card-footer>
</mat-card>
@if (service.loading) {
<div class="spinner-container">
  <mat-spinner></mat-spinner>
</div>
}
